import React from 'react';
import styles from "./popup.module.scss";
import { formatNumberWithDot, imageLink} from '../../../hooks/utils';

const PopUpDetail = ({item, onClose}) =>{

    const country = item.country;
    const city = item.city;
    const growthPercent = item.HNWIGrowth + '%' ;
    const millionaires = formatNumberWithDot(item.millionaires);
    const multiMillionaires = formatNumberWithDot(item.multiMillionaires);
    const centiMillionaires = formatNumberWithDot(item.centiMillionaires);
    const billionaires = item.billionaires? formatNumberWithDot(item.billionaires) : '-';

    const linkText = `Apply for residence in ${country}`;
    const link = item.link? (<p className={`mt20 mb-0 ${styles.bottomNote}`}>{linkText} <a href={item.link} target="_blank" rel="noreferrer" className="text-underline">here</a></p>) : '';

  

    return(
        <div className={`${styles.popup} ${styles.card}`}>
        
            <div className="row">
                <div className="col-12">
                
                    <div className={styles.imageWrapper}>
                        <img src={imageLink(city)} alt={city} />
                    </div>
                </div>
                <div className="col-12">
                    <div className={styles.cardContent}>
                        <div className="row mb-3 align-items-center">
                            <div className="col">
                                <h3 className="mb-0">{city}</h3>
                            </div>

                            <div className="col-auto">
                                <button className={styles.closeButton} onClick={onClose}>
                                    <svg width="10px" height="9px" viewBox="0 0 10 9">
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <g transform="translate(-702.000000, -7.000000)" stroke="currentColor">
                                                <g transform="translate(700.692388, 4.692388)">
                                                    <g transform="translate(6.500000, 6.500000) rotate(45.000000) translate(-6.500000, -6.500000) ">
                                                        <line x1="6.5" y1="1" x2="6.5" y2="12"></line>
                                                        <line x1="6.5" y1="1" x2="6.5" y2="11.5" transform="translate(6.500000, 6.250000) rotate(-90.000000) translate(-6.500000, -6.250000) "></line>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </button>
                            </div>
                        
                        </div>

                        <hr className={styles.border} />

                        <div className={`row justify-content-between align-items-center ${styles.dataSet}`}>
                            <div className="col"><h5 className="field mb-0">HNWIs (USD1m+)</h5></div>
                            <div className="col-auto text-right"><span className={`text-nowrap ${styles.value}`}>{millionaires}</span></div>
                        </div>

                        <hr className={`mb10 ${styles.border}`}/>

                        <div className={`row justify-content-between align-items-center ${styles.dataSet}`}>
                            <div className="col"><h5 className="field mb-0">Multi-millionaires (USD10m+) </h5></div>
                            <div className="col-auto text-right"><span className={`text-nowrap ${styles.value}`}>{multiMillionaires}</span></div>
                        </div>

                        <div className={`row justify-content-between align-items-center ${styles.dataSet}`}>
                            <div className="col"><h5 className="field mb-0">Centi-millionaires (USD100m+)</h5></div>
                            <div className="col-auto text-right"><span className={`text-nowrap ${styles.value}`}>{centiMillionaires}</span></div>
                        </div>

                        <div className={`row justify-content-between align-items-center ${styles.dataSet}`}>
                            <div className="col"> <h5 className="field mb-0">Billionaires (USD1bn+)</h5></div>
                            <div className="col-auto text-right"><span className={`text-nowrap ${styles.value}`}>{billionaires}</span></div>
                        </div>

                        <div className={`row justify-content-between align-items-center ${styles.dataSet}`}>
                            <div className="col"><h5 className="field mb-0">HNWI growth % (YTD 30 June 2022)</h5></div>
                            <div className="col-auto text-right"><span className={`text-nowrap ${styles.value}`}>{growthPercent}</span></div>
                        </div>


                        {link}
                    </div>
                </div>

            </div>
      </div>
    )
}

export default PopUpDetail;